import { Alert } from 'antd';
import React from 'react';
import CustomIcon from '../../CustomIcon/CustomIcon';

const NoRowsOverlay = ({ message = 'No data available' }) => {
  return (
    <Alert className="custom-alert-error" message={message} type="error" showIcon icon={<CustomIcon name="ErrorAlert" color="#FFFFFF" />} />
  );
};

export default NoRowsOverlay;
